import { call, fork, put, take } from 'redux-saga/effects';

import {
	REFUNDS_REQUESTING,
	REFUNDS_SUCCESS,
	REFUNDS_ERROR,
} from '@/redux/ducks/refunds/types';
import { INIT_APP_ERROR } from '@/redux/ducks/init/types';
import Api from '@/data';

export function* fetchRefund(payload) {
	try {
		yield put({
			type: REFUNDS_REQUESTING,
			payload,
		});
		const response = yield call(Api.getTransactionListNew, payload);

		yield put({
			type: REFUNDS_SUCCESS,
			data: response.data,
		});
	} catch (error) {
		if (error.status === 401) {
			yield put({ type: INIT_APP_ERROR, error: error.data });
		} else {
			yield put({ type: REFUNDS_ERROR, error: error.data });
		}
	}
}

export function* getRefundsList() {
	while (true) {
		const action = yield take(REFUNDS_REQUESTING);
		yield call(fetchRefund, action.payload);
	}
}

function* refundFlowSaga() {
	yield fork(getRefundsList);
}

export default refundFlowSaga;
